<div class="collage mb-1">
    <div class="wrapper services">
        <h3 *ngFor="let tag of tags">
            {{tag.descrizione}}
        </h3>
    </div>
</div>